module.exports = __webpack_public_path__ + "img/by.03d0cb81.svg";